import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@bindery/ui/components/theme/theme-provider";
import { App } from "./App";
import "./index.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("index.html lost its #root");
createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
);
